export default {
      id: "icon-pause-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }